import { formatDate } from '@/utils/date';
import type { MultiSeriesChartSeries } from './MultiSeriesChart';

interface TooltipPayloadEntry {
    payload?: Record<string, string | number | undefined | null>;
}

interface MultiSeriesChartTooltipProps {
    active?: boolean;
    payload?: TooltipPayloadEntry[];
    label?: string;
    series: MultiSeriesChartSeries[];
    valueFormatter?: (value: number) => string;
    titleFormatter?: (value: string) => string;
}

export function MultiSeriesChartTooltip({
    active,
    payload,
    label,
    series,
    valueFormatter,
    titleFormatter,
}: MultiSeriesChartTooltipProps) {
    const point = payload?.[0]?.payload;
    if (!active || !point) return null;

    const visible = series.filter((entry) => !entry.dimmed);
    if (visible.length === 0) return null;

    const bucketStart = Number(point.startTime);
    const title = Number.isFinite(bucketStart)
        ? formatDate(bucketStart)
        : titleFormatter && label
          ? titleFormatter(label)
          : label;

    return (
        <div className="rounded-[6px] border border-grey-600 bg-grey-700 px-3 py-2 shadow-[0px_4px_12px_-4px_rgba(7,8,10,0.4)]">
            <div className="mb-1 text-xs text-grey-300">{title}</div>
            {visible.map((entry) => {
                const raw = Number(point[entry.dataKey] ?? 0);
                return (
                    <div
                        key={entry.dataKey}
                        className="flex items-center gap-2 text-xs"
                    >
                        <span
                            className="size-2 shrink-0 rounded-full"
                            style={{ backgroundColor: entry.color }}
                        />
                        <span className="text-grey-200">{entry.label}</span>
                        <span className="ml-auto text-white-100">
                            {valueFormatter ? valueFormatter(raw) : raw}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}
